import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Image from '../components/content-blocks/Image';

const About = (props) => {
  return (
    <>
      <Container maxWidth='md' sx={{ py: { xs: 3, md: 5 } }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mt: 2,
          }}
        >
          <Typography variant='h1' component='h1'>About us</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 5,
            }}
          >
              <Image
                imageFileName='/images/lytton-center-logo.jpg'
                imageAlt='Lytton Center Logo'
              />
            <Typography variant='body1' sx={{ my: 3 }}>
              This project was sponsored by the Lytton Center
            </Typography>
            <Typography variant='body1'>
              All content is created and owned by Lisa Wesoloski, Ph.D.
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default About;
